import { useCallback, useEffect, useState } from "react";
import useUser from "./user";
import { AxiosError, AxiosInstance, isAxiosError } from "axios";
import api from "./api-new";
import { useRoomId } from "../components/context/room/room";

export const usePublisherToken = (axios: AxiosInstance) => {
  const roomId = useRoomId();
  const [user] = useUser();
  const [error, setError] =
    useState<AxiosError<{ status: string; message: string }>>();

  // Generate publisher token
  const [token, setToken] = useState<string | undefined>(undefined);
  const generateLivekitToken = api.useGenerateLivekitToken(axios);
  const generatePublisherToken = useCallback(async () => {
    setError(undefined);
    try {
      const response = await generateLivekitToken({
        room: roomId,
        identity: user.livekitId,
      });
      const { encodedToken } = response.data as { encodedToken: string };
      setToken(encodedToken);
    } catch (error) {
      if (!isAxiosError(error)) {
        throw error;
      }
      setError(error);
      if (error.response?.data.status !== 403) {
        throw error;
      }
    }
  }, [user.livekitId, roomId, generateLivekitToken]);
  useEffect(() => {
    const tokenRenewalInterval = setInterval(() => {
      generatePublisherToken();
    }, 9 * 60 * 1000);
    generatePublisherToken();
    return () => {
      clearInterval(tokenRenewalInterval);
    };
  }, [generatePublisherToken]);

  return { token, error };
};
